import { adsYellow } from "../utils/ADSColours";

const SpecialDesignationCode = [
  {
    id: 1,
    gpText: "Protected Street",
    osText: "Protected Road",
    colour: adsYellow,
    default: false,
  },
  {
    id: 2,
    gpText: "Traffic Sensitive",
    osText: "Traffic Sensitive",
    colour: adsYellow,
    default: false,
  },
  {
    id: 3,
    gpText: "Special Engineering Difficulty (SED)",
    osText: "Special Engineering Difficulty",
    colour: adsYellow,
    default: false,
  },
  {
    id: 6,
    gpText: "Proposed Special Engineering Difficulty",
    osText: undefined,
    colour: adsYellow,
    default: false,
  },
  {
    id: 7,
    gpText: undefined,
    osText: "Level Crossing (not Network Rail)",
    colour: adsYellow,
    default: false,
  },
  {
    id: 8,
    gpText: "Level Crossing Safety Zone",
    osText: "Bridge",
    colour: adsYellow,
    default: false,
  },
  {
    id: 9,
    gpText: "Environmentally Sensitive Areas",
    osText: "Road Trees",
    colour: adsYellow,
    default: false,
  },
  {
    id: 10,
    gpText: "Structures (not designated Special Engineering Difficulty)",
    osText: "Other Structure",
    colour: adsYellow,
    default: false,
  },
  {
    id: 11,
    gpText: undefined,
    osText: "Environmental Designations",
    colour: adsYellow,
    default: false,
  },
  {
    id: 12,
    gpText: "Pipelines and specialist cables",
    osText: "Loops in road surface",
    colour: adsYellow,
    default: false,
  },
  {
    id: 13,
    gpText: "Priority lanes",
    osText: "Pedestrian crossing",
    colour: adsYellow,
    default: false,
  },
  {
    id: 14,
    gpText: undefined,
    osText: "Service strips",
    colour: adsYellow,
    default: false,
  },
  {
    id: 16,
    gpText: "Lane Rental",
    osText: "Traffic calming features",
    colour: adsYellow,
    default: false,
  },
  {
    id: 17,
    gpText: "Streets subject to early notification of immediate activities",
    osText: "Traffic signals",
    colour: adsYellow,
    default: false,
  },
  {
    id: 18,
    gpText: "Special Events",
    osText: "Network Rail level crossing or Precautionary area",
    colour: adsYellow,
    default: false,
  },
  {
    id: 19,
    gpText: "Parking Bays and Restrictions",
    osText: "Traffic sensitive side road when temp traffic control is employed",
    colour: adsYellow,
    default: false,
  },
  {
    id: 20,
    gpText: "Pedestrian Crossings, Traffic Signals and Traffic Sensors",
    osText: "Hazardous Materials",
    colour: adsYellow,
    default: false,
  },
  {
    id: 21,
    gpText: "Speed Limits",
    osText: "Apparatus at a shallow depth",
    colour: adsYellow,
    default: false,
  },
  {
    id: 22,
    gpText: "Transport Authority Critical Apparatus",
    osText: undefined,
    colour: adsYellow,
    default: false,
  },
  {
    id: 23,
    gpText: "Strategic Route",
    osText: undefined,
    colour: adsYellow,
    default: false,
  },
  {
    id: 24,
    gpText: "Street Lighting",
    osText: undefined,
    colour: adsYellow,
    default: false,
  },
  {
    id: 25,
    gpText: "Drainage and Flood Risk",
    osText: undefined,
    colour: adsYellow,
    default: false,
  },
  {
    id: 26,
    gpText: "Unusual Traffic Layout",
    osText: undefined,
    colour: adsYellow,
    default: false,
  },
  {
    id: 27,
    gpText: "Local Considerations",
    osText: undefined,
    colour: adsYellow,
    default: false,
  },
  {
    id: 28,
    gpText: "Winter Maintenance Routes",
    osText: undefined,
    colour: adsYellow,
    default: false,
  },
  {
    id: 29,
    gpText: "HGV Approved Routes",
    osText: undefined,
    colour: adsYellow,
    default: false,
  },
  {
    id: 30,
    gpText: "Emergency Services Routes",
    osText: undefined,
    colour: adsYellow,
    default: false,
  },
];

export default SpecialDesignationCode;
